<script setup lang="ts">
import { matchInquiryTypeToIcon } from '@/utils/matchers'
import { INQUIRY_TYPE } from '@/types'

const props = defineProps({
  type: String as PropType<INQUIRY_TYPE>,
  isHighlighted: Boolean,
  classes: {
    type: String,
    required: false,
  },
})
</script>
<template>
  <div
    class="relative z-[-1] h-7 w-7 rounded-full bg-gray-200"
    :class="
      props.type == 'Unknown' ||
      props.type == 'Other' ||
      props.type == 'Reservation' ||
      props.type == 'Pick Up Order'
        ? 'p-[5.5px]'
        : 'p-1'
    "
  >
    <div
      v-if="isHighlighted"
      class="absolute -top-0 right-0.5 h-1.5 w-1.5 rounded-full bg-blue-600"
    ></div>
    <Component
      :is="matchInquiryTypeToIcon(props.type!)"
      :class="[
        isHighlighted ? 'fill-slate-600' : 'fill-gray-400',
        props.type == 'Unknown' ||
        props.type == 'Other' ||
        props.type == 'Reservation' ||
        props.type == 'Pick Up Order'
          ? 'h-4 w-4'
          : 'h-5 w-5',
        props.classes,
      ]"
    />
  </div>
</template>
